import { addToCartButtonStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToCartButton";
import { pageTitleStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";
import { css } from "styled-components";

addToCartButtonStyles.button = {
    css: css`
        width: auto;
    `,
};

pageTitleStyles.titleText = {
    variant: "h1",
    css: css`
        font-size: 32px !important;
    `,
};
